module.exports = __webpack_public_path__ + "img/train-intro6.8b7dad08.jpg";